angular.module('directives.dashboard').controller('wgtSettings',
    ['$scope', '$rootScope',
        function ($scope, $rootScope) {
            if ($scope.item.setting === undefined || $scope.item.setting === null ) {
                $scope.selectedSettingItem = '';
            } else {
                var selectedItem = parseInt($scope.item.setting);
                if(isNaN(selectedItem) && $scope.item.setting !== ""){
                    selectedItem = JSON.parse($scope.item.setting).locationIds[0];
                }
                $scope.selectedSettingItem = selectedItem;
            }
            $scope.saveSettings = function () {
                if ($scope.selectedSettingItem === null || $scope.selectedSettingItem === "" ) {
                    $scope.$parent.selectedLocation = '';
                    $scope.$parent.selectedLocationNumber = '';
                    $scope.$parent.selectedLocationId = 0;
                } else {
                    var location = $.grep($scope.currentUser.locations, function (e) {
                        return e.id === $scope.selectedSettingItem;
                    })[0];
                    $scope.$parent.selectedLocation = location.locationName;
                    $scope.$parent.selectedLocationNumber = location.locationNumber;
                    $scope.$parent.selectedLocationId = location.id;

                    $scope.selectedSettingItem = {locationIds: [angular.copy(location.id)]};
                }
                $scope.item.setting = $scope.selectedSettingItem;
                if ($scope.$parent) {
                    if ($scope.$parent.loadWidget) {
                        $scope.$parent.loadWidget();
                    }
                }
                $rootScope.$emit("widget.changed", $scope.item);

                $scope.$close();
            };
        }]);
